import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 m-4">
          <h3 className="text-red-800 font-semibold mb-1">Įvyko klaida</h3>
          <p className="text-red-600 text-sm">{this.state.error?.message}</p>
          <div className="mt-2 flex gap-2">
            <button
              className="px-3 py-1 text-sm bg-red-100 text-red-800 rounded hover:bg-red-200"
              onClick={() => this.setState({ hasError: false, error: null })}
            >
              Bandyti iš naujo
            </button>
            <button
              className="px-3 py-1 text-sm bg-white text-red-700 border border-red-200 rounded hover:border-red-400"
              onClick={() => window.location.reload()}
            >
              Perkrauti puslapį
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
